export default "/rabby.f6e1b6568592348cb0ba53abc9cd7d79.svg";